import $ from "jquery";
window.jQuery = $;
export function accordion(accordionItem) {
  const activeClass = "active";
  const fadeInClass = "fadein";
  const accordionContentClass = "accordion-content";
  const accordionTitleClass = "accordion-title";
  const group = accordionItem.closest(".accordion-group");
  const title = accordionItem.querySelector(`.${accordionTitleClass}`);
  const content = accordionItem.querySelector(`.${accordionContentClass}`);

  if(group.querySelectorAll('.accordion-item').length === 1) {
    accordionItem.classList.add(activeClass);
    accordionItem.classList.add(fadeInClass);
    $(content).slideDown();
  }

  title.addEventListener("click", function (e) {
    e.preventDefault();

    if (accordionItem.classList.contains(activeClass)) {
      accordionItem.classList.remove(activeClass, fadeInClass);

      $(content).slideUp();
    } else {
      const currentActive = group.querySelector(`.${activeClass}`);

      if (currentActive) {
        const currentActiveContent = currentActive.querySelector(
          `.${accordionContentClass}`
        );

        currentActive.classList.remove(activeClass, fadeInClass);

        $(currentActiveContent).slideUp();
      }

      accordionItem.classList.add(activeClass);

      setTimeout(() => {
        if (accordionItem.classList.contains(activeClass)) {
          accordionItem.classList.add(fadeInClass);
        }
      }, 200);

      $(content).slideDown();
    }
  });
}

export default function AccordionItem() {
  document.querySelectorAll(".accordion-item").forEach(function (item) {
    accordion(item);
  });
}
